"use client";

import { useAutoTranslate } from "@/lib/i18n/useAutoTranslate";
import React from "react";
import { IoIosSearch } from "react-icons/io";

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search here...",
  className,
}) => {
  const tr = useAutoTranslate();
  return (
    <div
      className={`flex items-center gap-2 border-light-border-gray border-1 border-solid w-full rounded-lg px-0.5 py-1 md:py-3 md:px-2 text-text-primary ${className}`}
    >
      <IoIosSearch size={24} className="!text-text-light" />
      <input
        type="search"
        placeholder={tr(placeholder)}
        value={value}
        onChange={onChange}
        className="w-full outline-0 placeholder:text-text-light bg-white text-sm md:text-base"
      />
    </div>
  );
};

export default SearchInput;
